import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { POST, GET } from "../../../../utils/Methods"; // Assume GET is imported/available
import { IDS } from "../../../../utils/IDS";

// Send Contact Us form
export const Create = createAsyncThunk(
  "/website/fund-raise/fundraise",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.RaiseFund.Raise, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// New: Fetch existing Fund Raise for prefill
export const GetFundRaise = createAsyncThunk(
  "/website/fund-raise/fundraise-get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.RaiseFund.Raise}/${id}`);

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Create2 = createAsyncThunk(
  "/website/fund-raise/fundraise2",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.RaiseFund.Raise2, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "raise",
  initialState: {
    data: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetContactState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetFundRaise.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetFundRaise.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
      })
      .addCase(GetFundRaise.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create2.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create2.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(Create2.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = Slice.actions;
export default Slice.reducer;
